<template>
    <div class="box">
        <Tabs @on-click="switchTab" :value="filter.selectType.toString()" :animated="false">
            <TabPane name="1" :label="$t('Button.labelMine')">
                <List v-if="filter.selectType == 1"></List>
            </TabPane>
            <TabPane v-if="hasDepPermission" name="2" :label="departmentName">
                <List v-if="filter.selectType == 2"></List>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import List from './List'

    export default {
        components: {
            List
        },
        data() {
            return {

            };
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.virtualOfficeTemplate.all.filter;
                },
                set(v) {
                    this.$store.commit("views/virtualOfficeTemplate.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.virtualOfficeTemplate.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/virtualOfficeTemplate.all.pagination", v);
                }
            },
            ...mapState({
                departmentName: state => state.department.currentName,
                isDepartmentAdmin: state => state.permission.isDepartmentAdmin,
                isSuperAdmin: state => state.permission.isSuperAdmin,
            }),
            hasDepPermission(){
                if(this.filter.depId && this.filter.depId != 0){
                    if(this.isSuperAdmin || this.isDepartmentAdmin){
                        return true;
                    }else return !!this.hasPermission('selectVirtualTemplateData');
                }else {
                    return false;
                }
            }
        },
        watch: {
            'filter.selectType'() {
                this.$store.commit('views/clearVirtualOfficeTemplateAll')
            }
        },
        methods: {
            switchTab(name){
                this.filter.selectType = parseInt(name);
            }
        },
        mounted() {

        },
        created() {

        },
        beforeDestroy() {

        }
    };
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {

    }
</style>